import React, { useState, useEffect } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import DateSelect from '../../../../components/AppInput/DateSelect'
import reportsServices from '../reportsServices';
import { Link } from 'react-router-dom';

function MemberRepeatedGrievanceReport() {
	const [filter,setFilter] =useState(null);
	const [memberList,setMemberList] = useState(null);

	const getMemberList = () =>{
		if(filter){
			setMemberList(null);
			const payload = {
				startDate:filter.startDate,
				endDate:filter.endDate
			}
			reportsServices.getMemberRepeatedGrievance(payload).then(res=>{
				setMemberList(res.data);
			}).catch(error=>{
			}).finally(()=>{
			})
		}
	}

	useEffect(()=>{
		getMemberList();
	},[filter])

  	return (
    <AppLayout>
      	<div className='container'>
			<div className='row mb-3'>
				<div className='col-md-12'>
					<div class="p-2 bg-dark text-center text-white rounded">
						<h3 className='mb-0' >User Repeated Grievance </h3>
					</div>
				</div>
			</div> 
			<div className='row'>
				<div className='col-md-12'>
					<span className='float-end'><DateSelect filter={filter} setFilter={setFilter} /></span>
				</div>
			</div>
			<div className='row'>
				<div className='col-md-12'>
					{memberList && 
						<table className='table'>
							<thead>
								<tr>
									<th>Phone Number</th>
									<th>Total Complaint</th>
								</tr>
							</thead>
							<tbody>
								{memberList.map(member=>
									<tr>
										<td><Link to={"/grievance/search/"+member.phone.substring(2)}> {member.phone}</Link></td>
										<td><Link to={"/grievance/search/"+member.phone.substring(2)}> {member.totalComplaint}</Link></td>
									</tr>	
								)}
							</tbody>
						
						</table>
					}
					
				</div>
			</div>
      	</div>
    </AppLayout>
  	)
}

export default MemberRepeatedGrievanceReport